import React from "react"
import { useRootContents } from "../../aggregators/rootData"
import { BrandLetterGroups } from "../../contents/brands/types"
import Typography from "../../ui/atoms/Typography"
import { CustomCol, CustomContainer, CustomRow } from "../../ui/spacings"
import EditorialContents from "../editorialPage/components/EditorialContents"
import BrandsPanel from "./components/BrandsPanel"
import BrandsSidebar from "./components/BrandsSidebar"

interface Props {
  contents: any
  brands: BrandLetterGroups
}

const BrandsPageContainer = ({ contents, brands }: Props) => {
  const { layout } = useRootContents()
  return (
    <>
      <EditorialContents contents={contents.data?.topContents} />
      <CustomContainer>
        <div className="mt-6 mb-8 text-center sm:mt-8 sm:mb-14 ">
          <Typography variant="h4" component="h1">
            {contents.data?.info?.title}
          </Typography>
        </div>
        <CustomRow>
          <CustomCol xs={0} sm={3} className="pr-16">
            <div
              className="sticky"
              style={{
                top: layout?.data.header.desktopTopPadding ?? 0,
              }}
            >
              <BrandsSidebar brands={brands} />
            </div>
          </CustomCol>
          <CustomCol xs={12} sm={9}>
            <BrandsPanel brands={brands} />
          </CustomCol>
        </CustomRow>
      </CustomContainer>
      <EditorialContents contents={contents.data?.bottomContents} />
    </>
  )
}

export default BrandsPageContainer
